// extracted by mini-css-extract-plugin
module.exports = {"form-structure":"style_form-structure__N_E12"};